import { DynamicLayer, DynamicLayerMetadata } from "../models/Layers";
import { Div, Icon, IconText, Section } from "trunx";
import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Instance } from "mobx-state-tree";
import { observer } from "mobx-react-lite";

interface DynamicLayerPanelProps {
  model: Instance<typeof DynamicLayer>;
  back: () => void;
}
const DynamicLayerPanel = ({
  model: { title, metadata, isVisible, toggleLayer },
  back,
}: DynamicLayerPanelProps) => {
  const LayerMenu = observer(
    ({ metadata }: { metadata: Instance<typeof DynamicLayerMetadata> }) => {
      return (
        <Div bulma="menu">
          <ul className="menu-list">
            {metadata.map(({ name, id }) => {
              return (
                <li key={`key-${id}`} onClick={() => toggleLayer(id)}>
                  <IconText>
                    <Icon bulma="is-left">
                      <FontAwesomeIcon
                        icon={isVisible(id) ? faCheckSquare : faSquare}
                      />
                    </Icon>
                    <span>{name}</span>
                  </IconText>
                </li>
              );
            })}
          </ul>
        </Div>
      );
    }
  );

  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={title} close={back} />
      </Div>
      <LeafletPanelBody>
        <Section>
          {metadata ? <LayerMenu metadata={metadata}></LayerMenu> : undefined}
        </Section>
      </LeafletPanelBody>
    </Div>
  );
};

export default observer(DynamicLayerPanel);
